import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import Company from '@/App/Company/Entity/Company'
import type { MeetingSharedDataRawData } from '@/Shared/AutoGenerated/Main'

export default class MeetingSharedData {
    constructor(
        public readonly appName: string,
        public readonly isFreePlan: boolean,
        public readonly company: Company,
        public readonly openCookieSettingsElementId: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(rawData: MeetingSharedDataRawData): MeetingSharedData {
        return new MeetingSharedData(
            rawData.appName,
            rawData.isFreePlan,
            Company.hydrateSingle(rawData.company),
            rawData.openCookieSettingsElementId,
        )
    }

    getLayoutProps(errorMessage: string | null) {
        return {
            appName: this.appName,
            isFreePlan: this.isFreePlan,
            company: this.company,
            errorMessage: errorMessage,
            openCookieSettingsElementId: this.openCookieSettingsElementId,
        }
    }
}
